import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { DotsCluster } from '../DotsCluster';

interface OptionProps {
  label: string;
  score: number;
  width: number;
  height: number;
  color: string;
}

const LABEL_HEIGHT_PERCENTAGE = 0.3;

export const Option = ({ label, score, width, height, color }: OptionProps) => {
  const scoreWidth = Math.max(32, Math.min(56, width / 3.5));

  return (
    <Box
      width={width}
      height={height}
      alignItems="center"
      justifyContent="center"
    >
      <DotsCluster
        dots={Array.from({ length: score }, (_, i) => ({
          id: `dot-${i}`,
          x: 0,
          y: 0,
          color,
          animatedRadius: 0,
        }))}
        radius={10}
        width={width}
        height={height * (1 - LABEL_HEIGHT_PERCENTAGE)}
      />
      <Box flexDirection="row" minHeight={height * LABEL_HEIGHT_PERCENTAGE}>
        <Text
          width={scoreWidth}
          textAlign="center"
          style={{ minWidth: scoreWidth }}
        >
          {score}
        </Text>
        <Text>{label}</Text>
      </Box>
    </Box>
  );
};
